import { Component, Injector } from '@angular/core';
import { BaseResourceListComponent, Coluna, Filtro, GlobalService, TransparenciaInformacaoAdicionalGrupo, LoginContabil, TransparenciaInformacaoAdicionalItem } from 'eddydata-lib';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { TransparenciaInformacaoAdicionalGrupoService } from './service/transparencia-informacao-adicional-grupo.service';

declare var $: any;

@Component({
  selector: 'app-transparencia-informacao-adicional-form',
  templateUrl: './transparencia-informacao-adicional-form.component.html',
  styleUrls: ['./transparencia-informacao-adicional-form.component.css']
})
export class TransparenciaInformacaoAdicionalFormComponent extends BaseResourceListComponent<TransparenciaInformacaoAdicionalItem, LoginContabil> {

  /**
   * Declaração de variáveis
   */
  public ptBR: any;
  public especie: string;

  public listaGrupos: Array<TransparenciaInformacaoAdicionalGrupo> = [];

  public entidade: TransparenciaInformacaoAdicionalGrupo = new TransparenciaInformacaoAdicionalGrupo();

  public exibirFooter: boolean = true;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    private messageService: MessageService,
    private globalService: GlobalService,
    private transparenciaInformacaoAdicionalGrupoService: TransparenciaInformacaoAdicionalGrupoService) {
    super(transparenciaInformacaoAdicionalGrupoService, injector);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected relations(): string {
    return 'orgao';
  }

  protected condicoesGrid(): {} {
    const parametros = {};
    parametros['orgao.id'] = this.login.orgao.id;
    return parametros;
  }

  protected ordenacaoGrid(): string[] {
    return ['descricao', 'nome'];
  }

  protected filtrosGrid(): Filtro {
    return {
      text: ['descricao', 'nome', 'link']
    };
  }

  public beforeInit(): void {
  }

  protected afterInit(): void {
    window.scrollTo(0, 0);
    this.ptBR = this.globalService.obterDataBR();
    this.preencherGrupos();
    this.filtro = '';
  }

  protected acaoRemover(model: TransparenciaInformacaoAdicionalGrupo): Observable<TransparenciaInformacaoAdicionalGrupo> {
    return null;
  }

  public obterParametros() {
    const parametros = super.obterParametros();
    parametros['relations'] = this.relations();

    switch (this.col) {
      case 1:
        parametros['orderBy'] = `nome$${this.ascendente ? 'ASC' : 'DESC'}`;
        break;
      case 2:
        parametros['orderBy'] = `descricao$${this.ascendente ? 'ASC' : 'DESC'}`;
        break;
      case 3:
        parametros['orderBy'] = `link$${this.ascendente ? 'ASC' : 'DESC'}`;
        break;
      default:
        break;
    }
    return parametros;
  }

  public preencherGrid() {
    const parametros = this.obterParametros();
    this.transparenciaInformacaoAdicionalGrupoService
      .filtrar(
        this.paginaCorrente,
        this.limite,
        parametros
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        lista => {
          this.lista = lista.content;
          this.paginaTotal = lista.totalPages;
        },
      );
  }

  protected colunasRelatorio(): string[] | Coluna[] {
    return [];
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================


  public cadastrarGrupo() {
    this.entidade = new TransparenciaInformacaoAdicionalGrupo();
    this.entidade.orgao = this.login.orgao;
    $('#dialogGrupo').modal('show');
  }

  public async salvarGrupo() {
    if (!this.entidade.nome) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Informe o nome' });
      return;
    }

    const link = this.entidade.link?.trim(); // Garante que não tenha só espaços

    const regex = /^https?:\/\/[^\s\/?#]+(:\d+)?(\/[^\s]*)?$/;

    if (!link) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Informe o link',
      });
      return;
    }

    if (!regex.test(link)) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Informe um link válido (ex: https://site.com)',
      });
      return;
    }

    if (!this.entidade.descricao) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Informe uma descrição' });
      return;
    }
    try {
      this.transparenciaInformacaoAdicionalGrupoService
        .inserir(this.entidade).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          $('#dialogGrupo').modal('hide');
          this.preencherGrupos();
          this.preencherGrid();
          this.entidade = new TransparenciaInformacaoAdicionalGrupo();
          this.messageService.add({ severity: 'success', summary: 'Informação', detail: 'Link salvo com sucesso!' });
        }, (res) => {
          this.messageService.add({ severity: 'error', summary: 'Validação', detail: res.error.payload });
        });
    } catch (ex) {
      toastr.error(ex.message ? ex.message : ex);
    }
  }

  public preencherGrupos() {
    this.transparenciaInformacaoAdicionalGrupoService.filtrar(this.paginaCorrente,
      this.limite,
      { 'orgao.id': this.login.orgao.id }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaGrupos = res.content;
        for (const item of this.listaGrupos) {
          item['editavel'] = false;
        }
      });
  }

  public remover(item: TransparenciaInformacaoAdicionalGrupo) {
    if (item.id) {
      this.transparenciaInformacaoAdicionalGrupoService.remover(item.id).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          toastr.info('Registro removido com sucesso!', 'Exclusão');
          this.lista.splice(this.lista.indexOf(item), 1);
          this.preencherGrid()
        }, (err) => toastr.error(err.error.payload));
    }
  }

  public editar(item: TransparenciaInformacaoAdicionalGrupo) {
    item['editavel'] = true;
    item['anterior'] = Object.assign({}, item);
    this.entidade = item;
  }

  public ItemEditavel(): boolean {
    return this.lista?.some((item: any) => item.editavel) ?? false;
  }

  public cancelar(item: TransparenciaInformacaoAdicionalGrupo) {
    item['editavel'] = false;
    this.transparenciaInformacaoAdicionalGrupoService.filtrar(1, -1, { 'orgao.id': this.login.orgao.id, relations: 'orgao' }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaGrupos = res.content;
        for (const item of this.listaGrupos) {
          item['editavel'] = false;
        }
      });
  }

  public salvar(item: TransparenciaInformacaoAdicionalGrupo) {
    // Validações básicas antes de enviar
    if (!item.nome || !item.descricao || !item.link) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Preencha todos os campos!' });
      return;
    }

    this.transparenciaInformacaoAdicionalGrupoService.atualizar(item)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        item['editavel'] = false;
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Registro atualizado!' });
      }, (err) => {
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: err.error.payload });
      });
  }

  public mostrarBotoes() {
    this.exibirFooter = true;
  }

  public esconderBotoes() {
    this.exibirFooter = false;
  }
}
